import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=6c7902a4&scoped=true"
import script from "./PageFooter.vue?vue&type=script&lang=js"
export * from "./PageFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7902a4",
  null
  
)

export default component.exports